import { ChildGenderEnum } from '@sola/schema/dotcom/children/childUtilityInterfaces.ts';
import {
  BadgeColors,
  FlexibleContentProps,
  NavigationProps,
  SectionMeta,
  ThemesEnum,
} from '@sola/schema/lib/schema.ts';

const image1 =
  'https://enterprise-2.content.tenovos.io/1652082776933/83289ea6-51ce-407c-b055-9a784ed66f27/efbed0d8-455f-40a9-b9de-b92b1e5c27c1-700x700.webp';
const image2 =
  'https://enterprise-2.content.tenovos.io/1652082776933/15545076-a2b3-49b0-91aa-ab703da5c18c/04d1c357-c942-479f-b5d2-a09aa1fbc5fe-700x700.webp';
const image3 =
  'https://enterprise-2.content.tenovos.io/1652082776933/18d79a5a-06ed-4e95-8bc4-04bee255c759/20e74d52-cda3-4f4d-8541-6a43862efdc0-700x700.webp';
const image4 =
  'https://enterprise-2.content.tenovos.io/1652082776933/83289ea6-51ce-407c-b055-9a784ed66f27/efbed0d8-455f-40a9-b9de-b92b1e5c27c1-700x700.webp';
const image5 =
  'https://enterprise-2.content.tenovos.io/1652082776933/15545076-a2b3-49b0-91aa-ab703da5c18c/04d1c357-c942-479f-b5d2-a09aa1fbc5fe-700x700.webp';
const image6 =
  'https://enterprise-2.content.tenovos.io/1652082776933/18d79a5a-06ed-4e95-8bc4-04bee255c759/20e74d52-cda3-4f4d-8541-6a43862efdc0-700x700.webp';

const imageVertical =
  'https://images.ctfassets.net/v1fsq8y1pr0o/4orJPpn3mzlky1rWiaKbiu/fd605354b9d8f4e6dde6011105f75795/56cdc4eaece6bb5fad5ae963469b3101.png';

export const mockMediaImage = {
  caption: 'caption',
  image: { url: image1, alt: 'image alt', width: 700, height: 467 },
};

export const mockMediaImage2 = {
  caption: 'caption2',
  image: { url: image2, alt: 'image alt 2', width: 700, height: 467 },
};

export const mockMediaImage3 = {
  caption: 'caption3',
  image: { url: image3, alt: 'image alt 3', width: 700, height: 467 },
};

export const mockMediaVideo = {
  caption: 'caption',
  image: { url: image2, alt: 'image alt', width: 700, height: 467 },
  video: {
    url: 'https://player.vimeo.com/video/152685985',
    autoplay: false,
    hasProgrammaticButton: true,
  },
};

export const mockItem = {
  title: 'Title',
  subtitle: 'Subtitle',
  body: (
    <p>
      Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
      donec. Elit pellentesque at nibh ut sollicitudin odio felis nisl vitae.
    </p>
  ),
  primaryCTA: {
    title: 'Link',
    link: 'https://www.compassion.com',
  },
  secondaryCTA: {
    title: 'Link',
    link: 'https://www.compassion.com',
  },
};

export const mockItemHeaderGroup = {
  ...mockItem,
  tertiaryCTA: {
    title: 'Link',
    link: 'https://www.compassion.com',
  },
};

export const mockFragmentQuotation: FlexibleContentProps = {
  ...mockItem,
  media: mockMediaImage,
  quotation: {
    text: '97% of compassion children were released from poverty',
    attribution: 'Attribution',
  },
};

export const mockItemIcon = {
  ...mockItem,
  icon: 'alert-triangle',
};

export const mockItemIconBadge = {
  ...mockItem,
  icon: 'heart',
  badge: {
    text: 'Badge',
    color: 'positive' as BadgeColors,
  },
};

export const mockItemImageBadge = {
  ...mockItem,
  icon: 'heart',
  badge: {
    text: 'Badge',
    color: 'positive' as BadgeColors,
  },
  media: mockMediaImage,
};

export const mockItemStat = {
  ...mockItem,
  title: '90%',
};

export const mockItemImage = {
  ...mockItem,
  media: mockMediaImage,
};

export const mockItemVideo = {
  ...mockItem,
  media: mockMediaVideo,
};

export const mockItemImageNoBody = {
  ...mockItem,
  media: mockMediaImage,
  body: undefined,
};

export const mockGalleryItems = [
  {
    ...mockItem,
    media: {
      caption: 'image 1 caption',
      image: { url: image1, alt: 'image alt', width: 700, height: 467 },
    },
  },
  {
    ...mockItem,
    media: {
      caption: 'image 2 caption',
      image: { url: image2, alt: 'image alt', width: 700, height: 467 },
      video: mockMediaVideo.video,
    },
  },
  {
    ...mockItem,
    media: {
      caption: 'image 3 caption',
      image: { url: imageVertical, alt: 'image alt', width: 641, height: 968 },
    },
  },
  {
    ...mockItem,
    media: {
      caption: 'image 4 caption',
      image: { url: image4, alt: 'image alt', width: 700, height: 467 },
    },
  },
  {
    ...mockItem,
    media: {
      caption: 'image 5 caption',
      image: { url: image5, alt: 'image alt', width: 700, height: 467 },
    },
  },
  {
    ...mockItem,
    media: {
      caption: 'image 6 caption',
      image: { url: image6, alt: 'image alt', width: 700, height: 467 },
    },
  },
];

// FLEX SECTION META PRESETS
export const FSmeta: SectionMeta = {
  theme: ThemesEnum.enum.white,
  fullWidth: false,
  dividerBelow: false,
  layoutRatio: '1-1',
  overlap: false,
  anchor: 'test-default',
};
export const FSmeta2Col: SectionMeta = {
  theme: ThemesEnum.enum.white,
  fullWidth: false,
  dividerBelow: false,
  layoutRatio: '2-1',
  overlap: false,
  anchor: 'test-default',
};

export const FSmetaLight: SectionMeta = {
  ...FSmeta,
  theme: ThemesEnum.enum.lightBlue,
  anchor: 'test-light',
};

export const FSmetaDark: SectionMeta = {
  ...FSmeta,
  theme: ThemesEnum.enum.darkBlue,
  anchor: 'test-dark',
};

export const FSmetaFullBleed: SectionMeta = {
  ...FSmeta,
  fullWidth: true,
};

export const FSmetaFullBleedLight: SectionMeta = {
  ...FSmetaFullBleed,
  theme: ThemesEnum.enum.lightBlue,
  anchor: 'test-light',
};

export const FSmetaFullBleedDark: SectionMeta = {
  ...FSmetaFullBleed,
  theme: ThemesEnum.enum.darkBlue,
  anchor: 'test-dark',
};

export const FSmetaFullBleedOverlap: SectionMeta = {
  ...FSmetaFullBleed,
  overlap: true,
  anchor: 'test-overlap',
};

export const baseProps: FlexibleContentProps = {};
//   title: 'Sponsorship could change everything for Alisson.',
//   body: (
//     <p>
//       By providing access to education, health care and basic necessities, child
//       sponsorship acts as a catalyst for lasting change. Children sponsored
//       through Compassion are surrounded by safe adults who know them
//       individually, live in the love of Jesus and offer the specific support
//       they need as they journey out of poverty.
//     </p>
//   ),
//   media: {
//     image: {
//       url: 'https://enterprise-2.content.tenovos.io/1652082776933/83289ea6-51ce-407c-b055-9a784ed66f27/efbed0d8-455f-40a9-b9de-b92b1e5c27c1-700x700.webp',
//       alt: 'picture',
//     },
//   },
//   primaryCTA: {
//     title: 'Sponsor Allison',
//     link: 'https://www.compassion.com',
//   },
// };

export const basePropsBlockQuote: FlexibleContentProps = {};
//   media: {
//     image: {
//       url: 'https://enterprise-2.content.tenovos.io/1652082776933/83289ea6-51ce-407c-b055-9a784ed66f27/efbed0d8-455f-40a9-b9de-b92b1e5c27c1-700x700.webp',
//       alt: 'picture',
//     },
//   },
//   quotation: {
//     text: '97% of compassion children were released from poverty',
//     attribution: 'Attribution',
//   },
// };

export const blockQuote: FlexibleContentProps = {};
//   quotation: {
//     text: '97% of compassion children were released from poverty',
//     attribution: 'Attribution',
//   },
// };

export const headerProps: FlexibleContentProps = {};
//   title: 'Header',
//   subtitle: 'Subtitle',
//   body: (
//     <p>
//       Lorem ipsum dolor sit amet consectetur. Et nibh lectus tempor orci
//       interdum turpis etiam et. Vestibulum urna gravida adipiscing vitae. Tellus
//       scelerisque vitae adipiscing proin laoreet massa facilisis consequat.
//       Pharetra nisi adipiscing sit.
//     </p>
//   ),
// };

export const iconProps: FlexibleContentProps = {};
//   title: 'An average title',
//   icon: 'church',
// };

export const iconPropsSimple: FlexibleContentProps = {};
//   title: 'An average title',
//   icon: 'church',
//   body: (
//     <p>
//       Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
//       donec. Lorem ipsum dolor sit amet consectetur.
//     </p>
//   ),
// };

export const iconCardProps: FlexibleContentProps = {};
//   title: 'An average title',
//   icon: 'church',
//   body: (
//     <p>
//       Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
//       donec. Lorem ipsum dolor sit amet consectetur.
//     </p>
//   ),
//   primaryCTA: {
//     title: 'Sponsor a Child',
//     link: 'https://www.compassion.com',
//   },
// };

export const eventProps: FlexibleContentProps = {};
//   title: 'Fort Smith, Montana',
//   subtitle: 'June 9-13, 2022',
//   body: (
//     <p>
//       Lorem ipsum dolor sit amet consectetur. Et nibh lectus tempor orci
//       interdum turpis etiam et. Vestibulum urna gravida adipiscing vitae. Tellus
//       scelerisque vitae adipiscing proin laoreet massa facilisis consequat.
//       Pharetra nisi adipiscing sit.
//     </p>
//   ),
//   media: {
//     image: {
//       url: 'https://enterprise-2.content.tenovos.io/1652082776933/62099120-0acf-4558-a9d3-5c2789666e32/29c427fa-205c-45cb-bb5e-eefd5e7ac16e-700x700.webp',
//       alt: 'picture',
//     },
//   },
//   primaryCTA: {
//     title: 'Register Now',
//     link: 'https://www.compassion.com',
//   },
//   secondaryCTA: {
//     title: 'Learn More',
//     link: 'https://www.compassion.com',
//   },
// };

export const statProps: FlexibleContentProps = {};
//   title: '00',
//   subtitle: 'stat item',
//   body: <p>Lorem ipsum dolor sit amet consectetur.</p>,
// };

// KITCHEN SINKS
export const mockContentSimple: FlexibleContentProps = {
  icon: 'church',
  subtitle: 'An average subtitle',
  title: 'An average length heading for a section',
  media: mockMediaImage,
  body: (
    <p>
      Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
      donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
      elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies
      cras elementum donec.
    </p>
  ),
  primaryCTA: {
    title: 'Button CTA',
    link: '#',
  },
};
export const mockContentHeading: FlexibleContentProps = {
  icon: 'family-gift',
  title: 'An average length heading for a section',
  subtitle: 'An average subtitle',
  body: (
    <p>
      Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
      donec. Lorem ipsum dolor sit amet consectetur.
    </p>
  ),
  primaryCTA: {
    title: 'Primary Action',
    link: '#',
  },
  secondaryCTA: {
    title: 'Secondary Action',
    link: '#',
  },
};

export const mockContentModerate: FlexibleContentProps = {
  ...mockContentSimple,
  body: (
    <p>
      Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
      donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
      elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies
      cras elementum donec.
    </p>
  ),
  badge: {
    text: 'Badge',
    color: 'negative',
  },
  quotation: {
    text: 'Quotation',
    attribution: 'Author',
  },
};

export const mockContentComplex: FlexibleContentProps = {
  ...mockContentModerate,
  media: mockMediaVideo,
  secondaryCTA: mockContentModerate.primaryCTA,
  tertiaryCTA: mockContentModerate.primaryCTA,
  subtitle:
    'A longer subtitle to show what happens if there is a lot of text - so much content, that it probably wraps onto a several lines',
  title:
    'A longer headline to show how it wraps and what happens if there is a lot of text - so much content, that it probably wraps onto a several lines',
  body: (
    <>
      <p>
        Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
        donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
        elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam
        ultricies cras elementum donec. Lorem ipsum dolor sit amet consectetur.
        Nullam ultricies cras elementum donec.
      </p>
      <ol>
        <li>
          <p>
            {
              'This will be a space return in a bulleted list. The purpose is to determine '
            }
            <a
              href="https://blog.compassion.com"
              target="_blank"
              rel="noopener noreferrer"
              // eslint-disable-next-line i18next/no-literal-string
            >
              what happens
            </a>
            {' on a new line with a lot of text and a link'}
          </p>
        </li>
        <li>
          <p>
            {
              'This will be a space return in a bulleted list. The purpose is to determine '
            }
            <a
              href="https://blog.compassion.com"
              target="_blank"
              rel="noopener noreferrer"
              // eslint-disable-next-line i18next/no-literal-string
            >
              what happens with a really really long link
            </a>
            {' on a new line with a lot of text and a link'}
          </p>
          <p>
            not possible probably, just including for testing sake{' '}
            <a href="https://blog.compassion.com">test</a> more text
          </p>
        </li>
        {Array(22)
          .fill(
            'Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam  ultricies cras elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum  donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras  elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum donec. Lorem ipsum dolor sit amet consectetur.  Nullam ultricies cras elementum donec.',
          )
          .map((text, index) => (
            <li key={index}>
              <p>{text}</p>
            </li>
          ))}
      </ol>
      <ul>
        <li>
          <p>test bullet points 1</p>
        </li>
        <li>
          <p>test bullet points 2</p>
        </li>
        <li>
          <p>test bullet points 3</p>
        </li>
        <li>
          <p>
            Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
            elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam
            ultricies cras elementum donec. Lorem ipsum dolor sit amet
            consectetur. Nullam ultricies cras elementum donec. Lorem ipsum
            dolor sit amet consectetur. Nullam ultricies cras elementum donec.
            Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
            elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam
            ultricies cras elementum donec. Lorem ipsum dolor sit amet
            consectetur. Nullam ultricies cras elementum donec. Lorem ipsum
            dolor sit amet consectetur. Nullam ultricies cras elementum donec.
          </p>
        </li>
        <li>
          <p>
            Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
            elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam
            ultricies cras elementum donec. Lorem ipsum dolor sit amet
            consectetur. Nullam ultricies cras elementum donec. Lorem ipsum
            dolor sit amet consectetur. Nullam ultricies cras elementum donec.
            Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
            elementum donec. Lorem ipsum dolor sit amet consectetur. Nullam
            ultricies cras elementum donec. Lorem ipsum dolor sit amet
            consectetur. Nullam ultricies cras elementum donec. Lorem ipsum
            dolor sit amet consectetur. Nullam ultricies cras elementum donec.
          </p>
        </li>
      </ul>
      <p>
        Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
        donec. Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras
        elementum donec.
      </p>
    </>
  ),
  logo: {
    logo: 'compassion',
    alt: 'Compassion',
  },
};

export const mockContentComplexItems: FlexibleContentProps = {
  ...mockContentModerate,
  items: [mockItem, mockContentModerate, mockContentComplex],
};

// MENUS
export const FooterMenuItem: NavigationProps = {
  title: 'Join Over 950,000 Subscribers!',
  description: 'Stay up to date on how God is working through our ministry.',
  items: [
    {
      title: 'My Account',
      link: 'https://compassion.com',
      items: [
        {
          title: 'View my Children',
          link: 'https://compassion.com',
        },
        {
          title: 'Write a Letter',
          link: 'https://compassion.com',
        },
        {
          title: 'Send a Gift',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'Sponsor a Child',
      link: 'https://compassion.com',
      items: [
        {
          title: 'View all Children',
          link: 'https://compassion.com',
        },
        {
          title: 'Find my Match',
          link: 'https://compassion.com',
        },
        {
          title: 'About Child Sponsorship',
          link: 'https://compassion.com',
        },
        {
          title: 'Child Sponsorship FAQs',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'Give',
      link: 'https://compassion.com',
      items: [
        {
          title: 'Donate',
          link: 'https://compassion.com',
        },
        {
          title: 'Philanthropy',
          link: 'https://compassion.com',
        },
        {
          title: 'Gift Catalog',
          link: 'https://compassion.com',
        },
        {
          title: 'Other Ways to Give',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'Get Involved',
      link: 'https://compassion.com',
      items: [
        {
          title: 'Partnerships',
          link: 'https://compassion.com',
        },
        {
          title: 'Compassion Sunday',
          link: 'https://compassion.com',
        },
        {
          title: 'Visit your Child',
          link: 'https://compassion.com',
        },
        {
          title: 'Volunteer',
          link: 'https://compassion.com',
        },
        {
          title: 'Pray',
          link: 'https://compassion.com',
        },
        {
          title: 'Write Your Child',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'About Us',
      link: 'https://compassion.com',
      items: [
        {
          title: 'About Compassion',
          link: 'https://compassion.com',
        },
        {
          title: 'Our Impact',
          link: 'https://compassion.com',
        },
        {
          title: 'Financial Integrity',
          link: 'https://compassion.com',
        },
        {
          title: 'FAQs',
          link: 'https://compassion.com',
        },
        {
          title: 'Careers',
          link: 'https://compassion.com',
        },
        {
          title: 'Contact Us',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'Stories & News',
      link: 'https://compassion.com',
      items: [
        {
          title: 'Stories',
          link: 'https://compassion.com',
        },
        {
          title: 'Crisis Updates',
          link: 'https://compassion.com',
        },
        {
          title: 'Press Center',
          link: 'https://compassion.com',
        },
      ],
    },
  ],
};

export const FooterSecondaryMenuItem: NavigationProps = {
  title: 'secondary items',
  items: [
    {
      title: 'Privacy Statement',
      link: 'https://www.compassion.com/privacy-policy.htm',
    },
    {
      title: 'Conditions of Use',
      link: 'https://www.compassion.com/conditions-of-use.htm',
    },
    {
      title: 'Disclosure Statement',
      link: 'https://www.compassion.com/about/disclosure-statement.htm',
    },
    {
      title: 'Cookie Preferences',
      link: 'https://www.compassion.com',
    },
  ],
};

export const FooterTrustIconsMenuItem: NavigationProps = {
  title: 'trust items',
  items: [
    {
      title: 'trust logo candid',
      icon: 'trust-guide-star',
    },
    {
      title: 'trust logo charity watch',
      icon: 'trust-charity-watch',
    },
    {
      title: 'trust logo ecfa',
      icon: 'trust-ecfa',
    },
    {
      title: 'trust logo bbb',
      icon: 'trust-bbb',
    },
    {
      title: 'trust logo seal of transparency guide star',
      icon: 'trust-seal-of-transparency-guide-star',
    },
  ],
};

export const FooterSocialMenuItem: NavigationProps = {
  title: 'social items',
  items: [
    {
      title: 'linkedin icon',
      icon: 'linkedin',
    },
    {
      title: 'facebook icon',
      icon: 'facebook',
    },
    {
      title: 'instagram icon',
      icon: 'instagram',
    },
    {
      title: 'twitter icon',
      icon: 'twitter',
    },
    {
      title: 'tiktok icon',
      icon: 'tiktok',
    },
  ],
};

export const DemoMenuItem: NavigationProps = {
  title: 'DEMO NAV',
  items: [
    {
      title: 'Sponsor a Child',
      link: 'https://compassion.com',
      items: [
        {
          title: 'View All Children',
          description: 'Browse all children in need of a sponsor.',
          icon: 'child',
          link: 'https://compassion.com',
          items: [],
        },
        {
          title: 'Find My Match',
          description: 'Help me choose based on a short, 5-question quiz.',
          icon: 'glasses-02',
          link: 'https://compassion.com',
        },
        {
          title: 'About Child Sponsorship',
          description:
            'Learn why sponsorship is a powerful way to defeat poverty.',
          icon: 'plant',
          link: 'https://compassion.com',
          badge: {
            text: 'Register',
            color: 'brand',
          },
        },
        {
          title: 'Child Sponsorship FAQs',
          description: 'Facilisi congue amet dictum volutpat egestas.',
          icon: 'message-question-circle',
          link: 'https://compassion.com',
        },
        {
          title: 'Current Sponsors',
          displayVariant: 'grid',
          link: 'https://compassion.com',
          items: [
            {
              title: 'Write',
              icon: 'edit-04',
            },
            {
              title: 'Give',
              icon: 'gift-01',
            },
            {
              title: 'Pray',
              icon: 'pray',
            },
            {
              title: 'Volunteer',
              icon: 'heart-hand',
            },
            {
              title: 'Visit',
              icon: 'globe-05',
            },
            {
              title: 'Login',
              icon: 'user-circle',
            },
          ],
        },
      ],
    },
    {
      title: 'Give',
      link: 'https://compassion.com',
      items: [
        {
          title: 'Donate',
          description:
            'Facilisi congue amet dictum volutpat egestas. Dui pellentesque libero faucibus ut pulvinar.',
          icon: 'bank-note-01',
          link: 'https://compassion.com',
          items: [
            {
              title: 'Where Most Needed',
              link: 'compassion.com/test1',
              badge: {
                text: 'Urgent',
                color: 'warning',
              },
            },
            {
              title: 'Current Featured Cause',
              link: 'compassion.com/test2',
            },
            {
              title: 'View All Causes',
              link: 'compassion.com/test3',
            },
          ],
        },
        {
          title: 'Philanthropy',
          description:
            'Give significant gifts that have the power to transform communities.',
          icon: 'heart-hand',
          link: 'https://compassion.com',
        },
        {
          title: 'Gift Catalog',
          description:
            'Facilisi congue amet dictum volutpat egestas. Dui pellentesque libero faucibus ut pulvinar.',
          icon: 'chicken',
          link: 'https://compassion.com',
          items: [
            {
              title: 'Most Popular Gifts',
              badge: {
                text: 'New',
                color: 'positive',
              },
            },
            {
              title: 'View by Category',
            },
            {
              title: 'View by Price',
            },
            {
              title: 'View All Gifts',
            },
          ],
        },
        {
          title: 'Other Ways to Give',
          description:
            'Facilisi congue amet dictum volutpat egestas. Dui pellentesque libero faucibus ut pulvinar.',
          icon: 'line-chart-up-02',
          link: 'https://compassion.com',
          items: [
            {
              title: 'Stocks',
            },
            {
              title: 'Estate & Asset (Wills) Giving',
            },
            {
              title: 'Non-Cash Giving',
            },
            {
              title: 'Contribution Matching',
            },
            {
              title: 'Donor Advised Funds',
            },
            {
              title: 'Volunteer',
            },
            {
              title: 'Give Cryptocurrency',
              badge: {
                text: 'Expiring Soon',
                color: 'negative',
              },
            },
          ],
        },
      ],
    },
    {
      title: 'Get Involved',
      link: 'https://compassion.com',
      items: [
        {
          title: 'Partnerships',
          description:
            'Together, we can break the chains of poverty for children in need.',
          icon: 'handshake',
          link: 'https://compassion.com',
          items: [
            {
              title: 'Churches',
            },
            {
              title: 'Corporate & Foundation',
            },
            {
              title: 'Pro Athletes',
            },
            {
              title: 'Artists',
            },
            {
              title: 'Speakers & Alumni',
            },
            {
              title: 'Events & Festivals',
            },
            {
              title: 'Philanthropy',
            },
          ],
        },
        {
          title: 'Compassion Sunday',
          description:
            'Speak up in your church on behalf of children in poverty.',
          icon: 'church',
          link: 'https://compassion.com',
        },
        {
          title: 'Field Experiences',
          description: 'Join a trip to the field to see Compassion in action.',
          icon: 'globe-05',
          link: 'https://compassion.com',
        },
        {
          title: 'Volunteer',
          description:
            'Explore ways you can give your time to help children in need.',
          icon: 'volunteer',
          link: 'https://compassion.com',
        },
        {
          title: 'Pray',
          description:
            'Discover how you can pray for children living in poverty.',
          icon: 'pray',
          link: 'https://compassion.com',
        },
        {
          title: 'Write Your Child',
          description: 'Sponsors, write a message of encouragement today.',
          icon: 'edit-04',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'About Us',
      link: 'https://compassion.com',
      items: [
        {
          title: 'About Compassion International',
          description:
            'Speak up in your church on behalf of children in poverty.',
          icon: 'skippy',

          link: 'https://compassion.com',
        },
        {
          title: 'Our Impact',
          description: 'Join a trip to the field to see Compassion in action.',
          icon: 'chart-breakout-circle',
          link: 'https://compassion.com',
        },
        {
          title: 'Financial Integrity',
          description:
            'Explore ways you can give your time to help children in need.',
          icon: 'bank',
          link: 'https://compassion.com',
        },
        {
          title: 'FAQ',
          description:
            'Discover how you can pray for children living in poverty.',
          icon: 'message-question-circle',
          link: 'https://compassion.com',
        },
        {
          title: 'Careers',
          description: 'Sponsors, write a message of encouragement today.',
          icon: 'luggage-03',
          link: 'https://compassion.com',
        },
        {
          title: 'Contact Us',
          description: 'Sponsors, write a message of encouragement today.',
          icon: 'message-chat-circle',
          link: 'https://compassion.com',
        },
      ],
    },
    {
      title: 'Stories & News',
      link: 'https://compassion.com',
      items: [
        {
          title: 'Stories',
          description:
            'Speak up in your church on behalf of children in poverty.',
          icon: 'rss-01',
          link: 'https://compassion.com',
        },
        {
          title: 'Crisis Updates',
          description: 'Join a trip to the field to see Compassion in action.',
          icon: 'cloud-raining-03',
          link: 'https://compassion.com',
        },
        {
          title: 'Press Center',
          description:
            'Explore ways you can give your time to help children in need.',
          icon: 'newspaper',
          link: 'https://compassion.com',
        },
        {
          title: 'Follow Us',
          link: 'https://compassion.com',
          displayVariant: 'social',
          items: [
            {
              title: 'Facebook',
              icon: 'facebook',
            },
            {
              title: 'X (Twitter)',
              icon: 'twitter',
            },
            {
              title: 'Instagram',
              icon: 'instagram',
            },
            {
              title: 'TikTok',
              icon: 'tiktok',
            },
          ],
        },
      ],
    },
  ],
};

// @TODO: Is this the same as UserMenuNav in this file? Can we combine them?
export const DemoUserMenu: NavigationProps = {
  title: 'User Menu Demo',
  items: [
    {
      title: 'My Compassion',
      items: [
        {
          title: 'Home',
          icon: 'home-03',
          link: 'https://my.compassion.com',
        },
        {
          title: 'Notifications',
          icon: 'bell-03',
          link: 'https://my.compassion.com/notifications',
          badge: {
            text: '10',
          },
        },
        {
          title: 'My Sponsored Children',
          icon: 'children',
          link: 'https://my.compassion.com/commitments',
        },
        {
          title: 'Letter Writing',
          icon: 'file-heart-01',
          link: 'https://write.compassion.com/',
        },
        {
          title: 'Give a gift',
          icon: 'gift-01',
          link: 'https://my.compassion.com/child-gifts',
        },
        {
          title: 'Volunteering',
          icon: 'volunteer',
          link: 'https://my.compassion.com/volunteer',
        },
      ],
    },
    {
      title: 'Account Management',
      items: [
        {
          title: 'Payments & Billing',
          icon: 'wallet-02',
          link: 'https://my.compassion.com/payments-and-billing',
        },
        {
          title: 'Settings',
          icon: 'settings-01',
          link: 'https://my.compassion.com/settings',
        },
        {
          title: 'Log Out',
          icon: 'log-out-01',
          link: 'https://auth.compassion.com/logout',
        },
      ],
    },
  ],
};

export const DemoMenuItemOneLevel: NavigationProps = {
  title: 'DEMO NAV',
  items: [
    {
      title: 'Sponsor a Child',
      link: 'https://compassion.com',
    },
    {
      title: 'Give',
      link: 'https://compassion.com',
    },
    {
      title: 'Get Involved',
      link: 'https://compassion.com',
      items: [],
    },
  ],
};

export const EmbeddedNavItem: NavigationProps = {
  title:
    'Sem arcu risus elementum tellus nec sed rutrum quis suscipit quis erat.',
  items: [
    {
      title: 'Partnerships',
      link: 'https://compassion.com',
      description: 'This is the description',
      items: [
        {
          title: 'Churches',
          link: 'https://compassion.com',
        },
        {
          title: 'Corporate & Foundation',
          link: 'https://compassion.com',
        },
        {
          title: 'Pro Athletes',
          link: 'https://compassion.com',
        },
        {
          title: 'Events & Festivals',
          link: 'https://compassion.com',
        },
        {
          title: 'Speakers & Artists',
          link: 'https://compassion.com',
        },
        {
          title: 'Philanthropy',
          link: 'https://compassion.com',
        },
      ],
    },

    {
      title: 'Compassion Sunday',
      link: 'https://compassion.com',
      description: 'Speak up in your church on behalf of children in poverty.',
    },

    {
      title: 'Visit Your Child',
      link: 'https://compassion.com',
      description: 'Join a trip to the field to see Compassion in action.',
    },

    {
      title: 'Volunteer',
      link: 'https://compassion.com',
      description:
        'Explore ways you can give your time to help children in need.',
    },

    {
      title: 'Pray',
      link: 'https://compassion.com',
      description: 'Discover how you can pray for children living in poverty.',
    },

    {
      title: 'Write Your Child',
      link: 'https://compassion.com',
      description: 'Sponsors, write a message of encouragement today.',
    },

    {
      title: 'Gift Catalog',
      link: 'https://compassion.com',
      description:
        'Give a child life-changing gifts such as food, education and more.',
      items: [
        {
          title: 'Most Popular Gifts',
          link: 'https://compassion.com',
        },
        {
          title: 'View by Category',
          link: 'https://compassion.com',
        },
        {
          title: 'View by Price',
          link: 'https://compassion.com',
        },
        {
          title: 'View All Gifts',
          link: 'https://compassion.com',
        },
      ],
    },

    {
      title: 'Philanthropy',
      link: 'https://compassion.com',
      description:
        'Give significant gifts that have the power to transform communities.',
    },

    {
      title: 'Donate',
      link: 'https://compassion.com',
      description:
        'Facilisi congue amet dictum volutpat egestas. Dui pellentesque libero faucibus ut pulvinar.',
      items: [
        {
          title: 'Where Most Needed',
          link: 'https://compassion.com',
        },
        {
          title: 'Current Featured Cause',
          link: 'https://compassion.com',
        },
        {
          title: 'View All Causes',
          link: 'https://compassion.com',
        },
      ],
    },

    {
      title: 'Other Ways to Give',
      link: 'https://compassion.com',
      description: 'Stocks, physical donations, cryptocurrency, and more.',
      items: [
        {
          title: 'Stocks',
          link: 'https://compassion.com',
        },
        {
          title: 'Estate & Asset (Wills) Giving',
          link: 'https://compassion.com',
        },
        {
          title: 'Non-Cash Giving',
          link: 'https://compassion.com',
        },
        {
          title: 'Contribution Matching',
          link: 'https://compassion.com',
        },
        {
          title: 'Donor Advised Funds',
          link: 'https://compassion.com',
        },
        {
          title: 'Volunteer',
          link: 'https://compassion.com',
        },
        {
          title: 'Give Cryptocurrency',
          link: 'https://compassion.com',
        },
      ],
    },

    {
      title: 'Empty Children Array',
      link: 'https://compassion.com',
      description:
        'Facilisi congue amet dictum volutpat egestas. Dui pellentesque libero faucibus ut pulvinar.',
      items: [],
    },
  ],
};

export const UserMenuNav = {
  subNavCollection: {
    items: [
      {
        link: 'https://www.compassion.com/my-account/summary.htm',
        title: 'Go to My Account',
        summary: null,
        icon: 'user',
      },
      {
        link: 'https://www.compassion.com/my-account/sponsorships-detail.htm',
        title: 'View My Sponsored Children',
        summary: null,
        icon: 'children',
      },
      {
        link: 'https://write.compassion.com',
        title: 'Write a Letter',
        summary: null,
        icon: 'file-heart',
      },
      {
        link: 'https://www.compassion.com/my-account/child-gifts.htm',
        title: 'Send a Gift',
        summary: null,
        icon: 'gift',
      },
      {
        link: 'https://www.compassion.com/my-account/additional-giving.htm',
        title: 'Give to a Fund or Cause',
        summary: null,
        icon: 'wallet-02',
      },
      {
        link: 'https://www.compassion.com/my-account/make-a-payment.htm',
        title: 'Make a Payment',
        summary: null,
        icon: 'receipt-check',
      },
    ],
  },
};

export const mockFund = {
  id: '1234',
  tcmId: '123',
  fundTitle: '123',
  fundCodeOneTime: '123',
  fundCodeCommitment: '123',
  interventionId: '123',
  minOneTimeAmount: 5,
  icon: 'church',
  donationLimitTotal: 1000,
  availableFrequencies: ['OneTime', 'Monthly'],
};

// FUND
export const mockDonation = {
  ...mockItem,
  body: (
    <p>
      Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
      donec. Elit pellentesque at nibh ut sollicitudin odio felis nisl vitae.
    </p>
  ),
  media: mockMediaImage,
  fund: {
    ...mockFund,
    suggestedAmount: 100,
    suggestedAmountsOneTime: [
      { value: 50 },
      { value: 100 },
      { value: 250 },
      { value: 500 },
    ],
    suggestedAmountsMonthly: [
      { value: 5 },
      { value: 10 },
      { value: 25 },
      { value: 50 },
    ],
  },
};
export const mockDonationSuggested = {
  ...mockItem,
  body: (
    <p>
      Lorem ipsum dolor sit amet consectetur. Nullam ultricies cras elementum
      donec. Elit pellentesque at nibh ut sollicitudin odio felis nisl vitae.
    </p>
  ),
  media: mockMediaImage,
  fund: {
    ...mockFund,
    suggestedAmount: 100,
  },
};
export const mockCatalogItem = {
  ...mockItem,
  fund: {
    ...mockFund,
    suggestedAmountsMonthly: [
      { value: 50, label: '1 item' },
      { value: 100, label: '2 items' },
      { value: 250, label: '5 items' },
      { value: 500, label: '10 items' },
    ],
  },
};

export const childAvailabilityMock = {
  age: 2,
  birthDate: '2023-09-13',
  holdExpirationDate: null,
  fieldOffice: 'HT',
  gender: ChildGenderEnum.Female,
  globalId: '10647374',
  holdingGlobalPartnerId: null,
  icp: { country: 'Haiti', id: 'HA0128' },
  imageUrl:
    'https://media.ci.org/w_150/v1726152597/ChildPhotos/Published/10647374_cfflyq.jpg',
  isInHivAffectedArea: false,
  isOrphan: false,
  isSpecialNeeds: false,
  localId: 'HA012805252',
  minDaysWaiting: 552,
  name: { first: 'Nahomie Anne', preferred: 'Anne' },
  priorityScore: 551,
  state: 'Available',
  sourceCode: null,
  waitingSinceDate: '2024-09-12',
};

export const childDetailsMock = {
  ageInYearsAndMonths: '2 Years 6 Months',
  birthDate: '2023-09-13 00:00:00',
  chronicIllness: [],
  cluster: 'cayes',
  cognitiveAgeGroup: '0-2',
  community: 'Cance',
  compassId: '',
  correspondenceLanguage: 'Creole',
  country: 'Haiti',
  education: {
    academicPerformance: null,
    formalLevel: '',
    gradeLevel: { local: 'Not Enrolled', us: 'Not Enrolled' },
    majorOrCourseOfStudy: null,
    notEnrolledInEducationReason: 'Under Age',
  },
  fieldOffice: 'Haiti',
  fundType: 'Sponsorship',
  gender: ChildGenderEnum.Female,
  globalId: '10647374',
  hangul: { name: '안네', preferred: '안네' },
  householdDuty: ['No Household Duties - Too Young'],
  icp: { country: 'Haiti', id: 'HA0128' },
  imageUrl:
    'https://media.ci.org/w_150/v1726152597/ChildPhotos/Published/10647374_cfflyq.jpg',
  interests: {
    christianActivityName: ['Only Attends Project'],
    favoriteProjectActivity: [],
    favoriteSchoolSubject: [],
    thingsILike: ['Clapping hands to rhythm'],
  },
  isInHivAffectedArea: false,
  isBirthDateEstimated: false,
  isOrphan: false,
  isSpecialNeeds: false,
  lastPhotoDate: '2024-09-12 00:00:00',
  lastReviewDate: '2024-09-12 00:00:00',
  localId: 'HA012805252',
  localNumber: '05252',
  name: { first: 'Nahomie Anne', preferred: 'Anne' },
  physicalDisability: [],
  plannedCompletion: {
    date: '2045-09-13 00:00:00',
    dateChangeReason: null,
  },
  primaryCaregiver: { name: 'Jean Pierre Odrese' },
  programDeliveryType: 'Home Based',
  recordType: 'Sponsorship Participant',
  reviewStatus: 'Approved',
  sourceKit: 'BeneficiaryKit',
  sponsorshipStatus: '',
  state: 'Active',
  status: 'Active',
  vocationalTrainingType: 'Not enrolled',
  householdList: [
    {
      femaleGuardian: {
        employmentStatus: 'Sometimes Employed',
        occupation: 'Agriculture / Farmer',
      },
      household: {
        id: 'H-04116831',
        name: 'NahomieAnneHousehold, François',
      },
      householdMemberList: [
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Jean Pierre Salomon',
          householdMemberRole: 'Uncle',
          isCaregiver: false,
          isPrimaryCaregiver: false,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Jean Pierre Odrese',
          householdMemberRole: 'Mother',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Francois Wasner',
          householdMemberRole: 'Father',
          isCaregiver: true,
          isPrimaryCaregiver: false,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Francois Ruth Wasline',
          householdMemberRole: 'Sister',
          isCaregiver: false,
          isPrimaryCaregiver: false,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Dada Pierre',
          householdMemberRole: 'Grandmother',
          isCaregiver: false,
          isPrimaryCaregiver: false,
        },
        {
          globalId: '10647374',
          localId: 'HA012805252',
          householdMemberName: 'Nahomie Anne François',
          householdMemberRole: 'Beneficiary - Female',
          isCaregiver: false,
          isPrimaryCaregiver: false,
        },
      ],
      maleGuardian: {
        employmentStatus: 'Sometimes Employed',
        occupation: 'Agriculture / Farmer',
      },
      parents: {
        naturalFather: { isAlive: 'Yes', isLivingWithChild: true },
        naturalMother: { isAlive: 'Yes', isLivingWithChild: true },
        maritalStatus: 'Married',
        together: 'Yes',
      },
      siblings: {
        numberOfBrothers: 0,
        numberOfSiblingChildren: 1,
        numberOfSisters: 2,
      },
      youthHeadedHousehold: false,
      revisedValues: 'RevisedValuesToUpdate',
      sourceKit: 'HouseholdKit',
    },
  ],
};
